export default "__VITE_ASSET__CPjraIDl__"